export default __webpack_public_path__ + "static/media/logo-us-newegg.2acaf96b.svg";